import { deliveryZonesColors } from "../../../../LiveOrders/services/orderDelivery";

export const getDeliveryZoneColor = (index: number) => {
	if (deliveryZonesColors.length === 0) return deliveryZonesColors[0];
	return deliveryZonesColors[index % deliveryZonesColors.length];
};
